/* tslint:disable */
/* eslint-disable */
/**
 * SR AAT specification
 * Description
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ConfigItem
 */
export interface ConfigItem {
    /**
     * 
     * @type {number}
     * @memberof ConfigItem
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ConfigItem
     */
    notes?: string;
    /**
     * 
     * @type {string}
     * @memberof ConfigItem
     */
    value?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ConfigItem
     */
    levelLocked?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ConfigItem
     */
    allowUserOverride?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ConfigItem
     */
    relatedProductName?: string;
    /**
     * 
     * @type {number}
     * @memberof ConfigItem
     */
    roleId?: number;
    /**
     * 
     * @type {number}
     * @memberof ConfigItem
     */
    productId?: number;
    /**
     * 
     * @type {number}
     * @memberof ConfigItem
     */
    propertyId?: number;
}

/**
 * Check if a given object implements the ConfigItem interface.
 */
export function instanceOfConfigItem(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ConfigItemFromJSON(json: any): ConfigItem {
    return ConfigItemFromJSONTyped(json, false);
}

export function ConfigItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConfigItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'notes': !exists(json, 'notes') ? undefined : json['notes'],
        'value': !exists(json, 'value') ? undefined : json['value'],
        'levelLocked': !exists(json, 'levelLocked') ? undefined : json['levelLocked'],
        'allowUserOverride': !exists(json, 'allowUserOverride') ? undefined : json['allowUserOverride'],
        'relatedProductName': !exists(json, 'relatedProductName') ? undefined : json['relatedProductName'],
        'roleId': !exists(json, 'roleId') ? undefined : json['roleId'],
        'productId': !exists(json, 'productId') ? undefined : json['productId'],
        'propertyId': !exists(json, 'propertyId') ? undefined : json['propertyId'],
    };
}

export function ConfigItemToJSON(value?: ConfigItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'notes': value.notes,
        'value': value.value,
        'levelLocked': value.levelLocked,
        'allowUserOverride': value.allowUserOverride,
        'relatedProductName': value.relatedProductName,
        'roleId': value.roleId,
        'productId': value.productId,
        'propertyId': value.propertyId,
    };
}

